import useCustomHook from '@/hooks/useCustomHook';
import { useCallback, useEffect, useRef } from 'react';
import { ResizeObserver } from '@juggle/resize-observer';

export default function AspectRatio({ className, children, ratio }) {
  const ref = useRef(null);
  const { state, actions } = useCustomHook({ defaultState: {}, actions: {} });

  const updateDimensions = useCallback(
    (entries) => {
      try {
        const stageRect = entries
          ? entries[0].contentRect
          : ref.current.getBoundingClientRect();

        const currentRadio = stageRect.width / stageRect.height;

        let width = 0;
        let height = 0;
        if (currentRadio > ratio) {
          height = stageRect.height;
          width = (stageRect.width * ratio) / currentRadio;
        } else {
          width = stageRect.width;
          height = (stageRect.height * currentRadio) / ratio;
        }
        document.documentElement?.style?.setProperty(
          '--activity-margin',
          `-${stageRect.height - height}px`
        );
        actions.setState({
          width: `${width}px`,
          height: `${height}px`,
          // marginLeft: `${(stageRect.width - width) / 2}px`,
        });
      } catch (error) {
        console.log(error);
      }
    },
    [ref.current, ratio]
  );

  useEffect(() => {
    let observer;
    if (ref.current != null) {
      updateDimensions();
      observer = new ResizeObserver(updateDimensions);
      observer.observe(ref.current);
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, [updateDimensions]);

  useEffect(() => {
    return () => {
      document.documentElement?.style?.setProperty('--activity-margin', '0');
    };
  }, []);

  return (
    <div
      ref={ref}
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          width: state.width,
          height: state.height,
          // marginLeft: state.marginLeft,
          position: 'absolute',
        }}
        className={className}
      >
        {children}
      </div>
    </div>
  );
}
